import { SystemMenuId } from '../../../model/system/menu';
import { Menu } from 'antd';
import { IAPIServiceConfigItem } from '../../../model/api-modules';
import { SvgIconName } from '../../../components/svg-icon/model';
import { SvgIcon } from '../../component/svg-icon';
import getFormatMessage from '../../../locales/get-format-message';

interface IProps {
  readonly selectedServiceConfig: IAPIServiceConfigItem;
  readonly configItem: IAPIServiceConfigItem | undefined;
}

export const ApplyMenuComponent = (props: IProps) => {
  const items = [
    {
      label: props.selectedServiceConfig.Name,
      key: SystemMenuId.Player,
      icon: (
        <span className="nav-icon">
          <SvgIcon
            icon={props.configItem?.IconURL as SvgIconName}
            width={16}
            className="icon-blue"
          />
        </span>
      ),
      children: [{ label: getFormatMessage('ready_to_access'), key: 'ready' }],
    },
  ];

  return (
    <Menu
      className="services-left-menu"
      items={items}
      mode="inline"
      defaultOpenKeys={[SystemMenuId.Player]}
      defaultSelectedKeys={['ready']}
      style={{ width: 200 }}
    />
  );
};
